import { FormFieldTextArea } from 'Components/FormField/FormFieldTextArea/FormFieldTextArea';

interface QuestionFreeformTextProps {
    formFieldId: string;
    onAnswerChanged: (text: string) => void;
    text: string;

    disabled?: boolean;
    formFieldLabel?: string;
}

export const QuestionFreeformText = (props: QuestionFreeformTextProps) => {
    return <FormFieldTextArea formFieldLabel={props.formFieldLabel ?? 'Answer'} formFieldId={props.formFieldId} handleChange={(event: React.FormEvent<HTMLInputElement>) => props.onAnswerChanged(event.currentTarget.value)} value={props.text} disabled={props.disabled} />;
};
